import { render } from "./Claim2_For.vue?vue&type=template&id=2267c4fa&scoped=true"
import script from "./Claim2_For.vue?vue&type=script&lang=js"
export * from "./Claim2_For.vue?vue&type=script&lang=js"

import "./Claim2_For.vue?vue&type=style&index=0&id=2267c4fa&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2267c4fa"

export default script